import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconScreenFit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.5 5.25C3.5335 5.25 2.75 6.0335 2.75 7V18C2.75 18.9665 3.5335 19.75 4.5 19.75H20.5C21.4665 19.75 22.25 18.9665 22.25 18V7C22.25 6.0335 21.4665 5.25 20.5 5.25H4.5ZM4.25 7C4.25 6.86193 4.36193 6.75 4.5 6.75H20.5C20.6381 6.75 20.75 6.86193 20.75 7V18C20.75 18.1381 20.6381 18.25 20.5 18.25H4.5C4.36193 18.25 4.25 18.1381 4.25 18V7ZM12.5001 8L14.2322 11H10.7681L12.5001 8ZM12.4999 17L10.7678 14H14.2319L12.4999 17Z",
		fill: "#707070"
	})
});
export default SvgIconScreenFit;
